export default {
  categories: null,
  citiesRaw: [
    {
      code: 3,
      name: "Bogota",
      parsedName: "bogota",
      countryCode: 2,
    },
    {
      code: 5,
      name: "Ciudad de México",
      parsedName: "ciudad-de-mexico",
      countryCode: 3,
    },
  ],
  city: {
    id: 3,
    code: 3,
    name: "Bogota",
    parsedName: "bogota",
    countryCode: 2,
  },
  currentProduct: null,
  productsSuggestions: [],
  productsSearch: [],
  isLoadingCategories: false,
  currentSuperCategory: null,
  currentCategory: null,
  productRecommendations: [],
};
